import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AssetComponent from "components/core/asset/asset-component.js";
import MondayMarkupLanguageComponent from "client/components/system/monday-markup-language/monday-markup-language-component";
import { StyledBadgesSectionComponent } from "./badges-section-component.scss.js";
export default function BadgesSectionComponent(props) {
    const { badgesSections } = props;
    return /*#__PURE__*/ _jsx(StyledBadgesSectionComponent, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "badges-sections-container",
            children: badgesSections === null || badgesSections === void 0 ? void 0 : badgesSections.map((badgesSection, index)=>{
                var _badgesSection_badges;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "badges-section",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "section-header",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "icon",
                                    children: /*#__PURE__*/ _jsx(AssetComponent, {
                                        image: {
                                            src: badgesSection === null || badgesSection === void 0 ? void 0 : badgesSection.icon
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "section-info",
                                    children: [
                                        /*#__PURE__*/ _jsx(MondayMarkupLanguageComponent, {
                                            className: "title",
                                            text: badgesSection === null || badgesSection === void 0 ? void 0 : badgesSection.title
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "description",
                                            children: badgesSection === null || badgesSection === void 0 ? void 0 : badgesSection.description
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "badges-container",
                            children: badgesSection === null || badgesSection === void 0 ? void 0 : (_badgesSection_badges = badgesSection.badges) === null || _badgesSection_badges === void 0 ? void 0 : _badgesSection_badges.map((badge, index)=>{
                                return /*#__PURE__*/ _jsx("div", {
                                    className: "badge",
                                    children: /*#__PURE__*/ _jsx(AssetComponent, {
                                        image: {
                                            src: badge === null || badge === void 0 ? void 0 : badge.badgeImage
                                        }
                                    })
                                }, index);
                            })
                        })
                    ]
                }, index);
            })
        })
    });
}
